import { Route } from "react-router-dom";
import { CreateInvoice, EditInvoice } from "../Invoice/Invoice";
import { ViewInvoices } from "../Invoice/Table/InvoiceList";

export const INVOICE_ROUTES = [
    <Route key="invoices" path="/invoices" element={<ViewInvoices />} />,
    <Route key="invoices-create" path="/invoices/create_invoice" element={<CreateInvoice />} />,
    <Route key="invoices-update" path="/invoices/update_invoice/:id" element={<EditInvoice />} />
];
